// Hook - lista kontaktow przypisanych do transakcji
// GET /api/ui/sales-crm/deals/{id}/contacts

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetDealContactsResponse } from 'api/types/deals';

const getDealContacts = (id: number): Promise<IGetDealContactsResponse> =>
  axios.get(`/sales-crm/deals/${id}/contacts`);

export const useGetDealContacts = (
  id: number,
  options?: UseQueryOptions<IGetDealContactsResponse, IError>,
) =>
  useQuery<IGetDealContactsResponse, IError>(
    ['sales-crm-deal-contacts', id],
    () => getDealContacts(id),
    {
      enabled: id > 0,
      ...options,
    },
  );
